/**
 * THE one line a rejected order shows: "Rejected by <name>, <date> — <reason>"
 * (owner ruling 2026-10-19, from a live mockup). It replaced the red
 * "Rejection Reason: X" line AND the rejecting step's repeated "Note: X" in
 * Order Progress — the reason is said ONCE, here (Pete: "the reason is also in
 * activity history").
 *
 * WHO and WHEN come from the LIST row's `rejection_info` ({ date, by, reason }),
 * which `GET /api/orders` and `GET /api/orders/department` attach from
 * `order_audit_log` (`server/helpers/orderTerminalInfo.js` — the one source
 * that covers BOTH rejection writers). The detail payload carries neither, so
 * a surface with no list row (the order page) passes no `info` and the line
 * degrades to "Rejected — <reason>": never a half-built "by , —".
 * `by` is a display-NAME string — display only, never identity.
 */
import React from 'react';
import { formatDate } from '../utils/dateFormat';

export function rejectionLineLead(info) {
  const by = info && info.by ? String(info.by).trim() : '';
  const date = info && info.date ? formatDate(info.date) : '';
  const when = date && date !== '-' ? date : '';
  if (by && when) return `Rejected by ${by}, ${when}`;
  if (by) return `Rejected by ${by}`;
  if (when) return `Rejected ${when}`;
  return 'Rejected';
}

export default function OrderRejectionLine({ reason, info = null, className = '', testId }) {
  if (!reason) return null;
  return (
    <p className={`text-sm text-red-700 dark:text-red-400 ${className}`} data-testid={testId}>
      <span className="font-medium">{rejectionLineLead(info)}</span>
      {' — '}
      <span>{reason}</span>
    </p>
  );
}
